export default "__VITE_ASSET__b7378ccd__"